import React, { useState, useEffect, useRef } from "react";
import { FaTimes } from "react-icons/fa";
import { useSelector } from "react-redux";
import axios from "axios";
import MapItem from "../MapItem/MapItem";
import Spinner from "../Spinner/Spinner";
import InputTooltip from "../InputTooltip/InputTooltip";
import "./MapModal.scss";

const MapModal = (props) => {
  const phoneRef = useRef();
  const addressRef = useRef();
  const [mobile, setMobile] = useState("");
  const [address, setAddress] = useState("");
  const [map, setMap] = useState([]);
  const user = useSelector((state) => state.user);

  useEffect(async () => {
    const getMapDetailById = props.getMapDetailById;
    if (getMapDetailById !== null) {
      await axios
        .get(`/account/getAddressById/${getMapDetailById}`, {
          headers: {
            Authorization: "Bearer " + user[0]?.token,
          },
        })
        .then((result) => {
          if (result.status === 200) {
            setMobile(result.data.data.phone);
            setAddress(result.data.data.address);
            let mp = [result.data.data.lat, result.data.data.lng];
            // setMarkerHandler(mp);
            setMap(mp);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
    let body = document.body;
    body.style.overflowY = "hidden";
    return () => {
      body.style.overflowY = "auto";
    };
  }, []);

  const mobileHandler = (e) => {
    setMobile(e.target.value.replace(/\D/, ""));
  };

  const addressHandler = (e) => {
    setAddress(e.target.value);
  };

  // const changeAddressToMap = () => { }
  // const changeMapToAddress = () => { }

  const setMarkerHandler = (e) => {
    setMap(e.latLng);
  };

  const deleteMapHandler = () => {
    // console.log("deleted!")
  };

  const editMapHandler = () => {
    // console.log("updated...")
  };

  const inputValidator = (action, input, tooltipId) => {
    let tooltip = document.getElementById(tooltipId);
    let isValid = 0;
    let message = "";
    if (action.regex) {
      let regex = action.regex.regex;
      if (regex.test(input.target.value)) {
        isValid -= 1;
      } else {
        message = action.regex.error;
        isValid += 1;
      }
    }
    if (action.required) {
      if (input.target.value !== "") {
        isValid -= 1;
      } else {
        isValid += 1;
        message = action.required;
      }
    }
    if (isValid >= 0) {
      tooltip.style.display = "flex";
      tooltip.innerText = message;
      input.target.style.border = "1px solid #f53b57";
      input.target.focus();
    } else {
      tooltip.style.display = "none";
      tooltip.innerText = "";
      input.target.style.border = "1px solid #b9b9b9";
    }
  };

  return (
    <div className="mapModalWrapper">
      <div className="mapModal">
        <div className="header">
          <span className="title">{props.title}</span>
          <span className="closeModal" onClick={props.closeModal}>
            <FaTimes />
          </span>
        </div>
        <div className="content">
          {props.getMapDetailById !== null && props.defaultCenter.length <= 0 ? (
            <MapItem
              defaultCenter={map.length > 0 ? map : [35.73853, 51.4326]}
              anchor={map.length > 0 ? map : [35.73853, 51.4326]}
              height={250}
              zoom={14}
              setMarkerHandler={setMarkerHandler}
              deleteMapHandler={deleteMapHandler}
              editMapHandler={editMapHandler}
              active={true}
              twoFingerDrag={true}
            />
          ) : (
            <MapItem
              defaultCenter={props.defaultCenter}
              anchor={map}
              height={250}
              zoom={14}
              setMarkerHandler={setMarkerHandler}
              deleteMapHandler={deleteMapHandler}
              editMapHandler={editMapHandler}
              active={true}
              twoFingerDrag={true}
            />
          )}

          <div className="mapForm">
            <div className="formGroup">
              <label>شماره موبایل</label>
              <input
                className="phoneInput"
                type="text"
                value={mobile}
                onChange={(e) => mobileHandler(e)}
                ref={phoneRef}
                onBlur={(input) =>
                  inputValidator(
                    {
                      required: "* شماره موبایل نمی تواند خالی باشد!",
                      regex: {
                        regex: /^(\+989|9|09)(03|12|19|35|36|37|38|39|32|30|28|22|21|20|00)\d{7}$/,
                        error: "* شماره موبایل معتبر نمی باشد!",
                      },
                    },
                    input,
                    "tooltipMobile"
                  )
                }
                placeholder="09127654321"
                pattern="[0-9\u06F0-\u06F9]{10}"
                maxLength="11"
              />
              <InputTooltip display="none" id="tooltipMobile" />
            </div>
            <div className="formGroup">
              <label>آدرس</label>
              <textarea
                className="addressInput"
                value={address}
                onChange={(e) => addressHandler(e)}
                ref={addressRef}
                placeholder="تهران"
                maxLength="255"
                onBlur={(input) =>
                  inputValidator(
                    {
                      required: "* آدرس نمی تواند خالی باشد!",
                      regex: {
                        regex: /^[،, \u0600-\u06FF\A-za-z0-9s]+$/,
                        error: "* آدرس معتبر نمی باشد!",
                      },
                    },
                    input,
                    "tooltipAddress"
                  )
                }
              ></textarea>
              <InputTooltip display="none" id="tooltipAddress" />
            </div>
            <div className="formGroup btn">
              {props.getMapDetailById !== null ? (
                <button
                  className="btnApplyMap"
                  onClick={() => props.updateMapHandler(mobile, address, map, props.getMapDetailById)}
                >
                  {props.showSpinner ? <Spinner color="#fff" /> : "ویرایش نقشه"}
                </button>
              ) : (
                <button className="btnApplyMap" onClick={() => props.submitMapHandler(mobile, address, map)}>
                  {props.showSpinner ? <Spinner color="#fff" /> : "ثبت نقشه"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="mapOverlay" onClick={props.closeModal}></div>
    </div>
  );
};

export default React.memo(MapModal);
